module.exports = __webpack_public_path__ + "img/ico_reembolso.d70abc59.svg";